export { default } from './SponsoredArticleLayout';
